import { Component, OnInit, AfterViewInit, ViewChild, ChangeDetectionStrategy, HostListener, ChangeDetectorRef } from '@angular/core'
import {
  trigger,
  state,
  style,
  transition,
  animate
} from '@angular/animations'
import { UserActivityService } from '@app/shared/services/user-activity.service'
import { Observable } from 'rxjs'
import { take, tap } from 'rxjs/operators'
import { Store } from '@ngrx/store'
import * as fromCoreStore from '@app/core/store'
import * as fromAuthStore from '@app/users/store'
import * as fromModalStore from '@app/modals/store'
import { GetNewVersionNotification } from '@app/core/store'
import { initFlowbite } from "flowbite"
import { SidebarService } from './services/sidebar.service'
import { PushNotifications } from './services/push-notifications.service'
import { NavigationEnd, Router } from '@angular/router'
import { filter } from 'jszip'
import { RedirectService } from '@app/shared'
import { Actions, ofType } from '@ngrx/effects'
import * as fromStore from '@app/users/store'
import * as AuthActions from '@app/users/store/actions'
import { Modal } from '@app/modals/models/modal.model'

declare var require: any

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('slideInOut', [
      state('in', style({
        transform: 'translate3d(0, 0, 0)'
      })),
      state('out', style({
        transform: 'translate3d(100%, 0, 0)'
      })),
      transition('in => out', animate('400ms ease-in-out')),
      transition('out => in', animate('400ms ease-in-out'))
    ])
  ],
  standalone: false
})
export class AppComponent implements OnInit, AfterViewInit {
  @ViewChild('mainContainer', { static: false })
  private mainContainer

  title = 'app works!';
  message
  menuState = 'out';
  appVersion = require('../../../package.json').version;
  activateMenu = false;
  routeUrl$: Observable<any>
  currentUser
  showNavigation = true
  isPublic = false;
  showSidebarRight = true
  showPreloader = true
  loggedIn = false
  windowWidth: number = window.innerWidth
  isSubscribed: boolean = false
  isFullscreen = false

  mobileShowSidebar: 'nav' | 'notify' | '' = ''

  modals: Modal[] = [];

  constructor(
    private store: Store<fromCoreStore.State>,
    private userActivityService: UserActivityService,
    private sidebarService: SidebarService,
    private _PushNotifications: PushNotifications,
    private cdr: ChangeDetectorRef,
    private router: Router,
    private redirectService: RedirectService,
    private actions$: Actions
  ) { }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.windowWidth = window.innerWidth
    if (this.loggedIn && !location.href.includes('/checkout/')) {
      this.showNavigation = true
      this.showSidebarRight = true
    }
    this.cdr.detectChanges()

  }

  onModalClose(type: string) {
    this.store.dispatch(new fromModalStore.CloseModal(type))
  }

  toggleMenu() {
    this.menuState = this.menuState === 'out' ? 'in' : 'out'
  }


  toggleSidebar() {
    this.sidebarService.setIsOpenSidebar(this.activateMenu)
  }

  ngOnInit() {
    this.sidebarService.showNavigation$.subscribe((showNav) => {
      this.showNavigation = showNav
      this.cdr.detectChanges()
    })

    document.addEventListener('fullscreenchange', () => {
      this.isFullscreen = !!document.fullscreenElement
      this.cdr.detectChanges()
    })

    this.store.select(fromModalStore.selectAllModals).subscribe(modals => {
      this.modals = modals
      this.cdr.detectChanges()
    })

    this.router.events
      .pipe()
      .subscribe((event: NavigationEnd) => {
        const currentUrl = window.location.href
        const hashPart = currentUrl.split('#/')[1]
        const firstSegment = hashPart?.split('/')[0]

        let users = this.redirectService.getSessions()
        users = (users || []).filter(u => u?.active && (u?.email == this.currentUser?.email))

        const isUserIndex = !isNaN(Number(firstSegment))
        let userIndex = 0
        if (users?.length) {
          userIndex = users[0]?.userIndex || 0
        }

        const parts = currentUrl.split("/")
        if (parts?.length > 4) {
          let pageName = parts[5]
          if (!pageName || !isNaN(Number(pageName))) {
            const newUrl = `#/${userIndex}/login`
            window.location.href = newUrl
          }
        }

        if (!isUserIndex) {
          setTimeout(() => {
            const newUrl = `#/${userIndex}/${hashPart}`
            window.location.href = newUrl
          }, 500)
        }
      })

    this.sidebarService.showSidebar$.subscribe((showSidebar) => {
      this.showSidebarRight = showSidebar
      this.cdr.detectChanges()
    })

    this.store.select(fromAuthStore.getLoggedIn).pipe(
      tap(logged => {
        this.loggedIn = logged
        if (logged && !location.href.includes('/checkout/')) {
          this.showNavigation = true
          this.showSidebarRight = true
        } else {
          this.showNavigation = false
          this.showSidebarRight = false
        }
        // Bug with sidebars on mobile
        this.cdr.detectChanges()
      })
    ).subscribe()

    if (typeof Notification === 'undefined') {
      window.Notification = function () { } as any
    }

    if (location.href.includes('/checkout/')) {
      this.showNavigation = false
      this.showSidebarRight = false
      this.showPreloader = false
    }
    Notification?.requestPermission?.()
    this.store.dispatch(new GetNewVersionNotification({ version: this.appVersion }))
    console.log('App Version: ', this.appVersion)
    this.store.select(fromCoreStore.getRouterState).pipe(
      tap(v => {
        if (location.href.includes('/checkout/')) {
          this.showNavigation = false
          this.showSidebarRight = false
          this.showPreloader = false
        }
        this.isPublic = v?.state?.data?.isPublic
      })
    ).subscribe()

    this.store.select(fromAuthStore.getUser).pipe(
      tap(user => {
        if (user) {
          this.currentUser = user
        }
      })
    ).subscribe()

    this.userActivityService.networkingUserActivityObs$.subscribe()

    initFlowbite()

    window.addEventListener("storage", (event) => {
      let currentUrl = window.location.href
      let userIndex = String(parseInt(currentUrl.match(/\/(\d+)\//)?.[1] || '0', 10) || 0)

      const key = `session/${userIndex}`
      let ignoreAuthMiss = location.href.includes('/checkout/') || location.href.includes('/terms-and-conditions')
      if (event?.key === key && event?.newValue === null && !ignoreAuthMiss) {
        this.store.dispatch(new fromAuthStore.Logout())
      } else if(event?.key === key && event?.newValue !== null && event?.oldValue === null && !ignoreAuthMiss){
        this.store.dispatch(new fromAuthStore.LoginToken({ reinitAfterLogin: true }))
      }
    }, false)

    if (location.href.includes('/checkout/')) {
      this.showNavigation = false
      this.showSidebarRight = false
      this.showPreloader = false
    }

  }

  ngAfterViewInit() {
    this._PushNotifications.init(async () => {
      const oneSignalState = await this._PushNotifications.getSubscriptionState()
      this.isSubscribed = oneSignalState ? oneSignalState.isPushEnabled : false
    })
    this.store.select(fromCoreStore.getRouterState)
      .pipe(
        tap(v => {
          if (this.mainContainer) {
            this.mainContainer.nativeElement.scrollTop = 0
          }
        })
      ).subscribe()
  }
}
